import { useLayoutEffect, useState } from 'react';

interface Dimensions {
  width: number;
  height: number;
}

export const useWindowDimensions = () => {
  const [size, setSize] = useState<Dimensions>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useLayoutEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
};
